import React from 'react';
import { Dialog, Typography, CircularProgress, Box } from '@mui/material';

import { circularProgressSizeProps } from '@opengov/capital-mui-theme';

import { IReportLocale } from '../../../locale';
import { styles } from './ReportCreatingModalMui.styles';
export interface IReportCreatingMsgs {
  title: string;
}
export interface IReportCreatingModalMui {
  reportLocaleText: IReportLocale;
}

export const ReportCreatingModalMui: React.FC<IReportCreatingModalMui> = (props) => {
  const { reportLocaleText } = props;

  return (
    <Dialog open={true} sx={styles.dialogContainer}>
      <Box sx={styles.innerContainer}>
        <CircularProgress {...circularProgressSizeProps.small} color="primaryShadowed" />
        <Typography data-test="report-creating-modal-title" variant="h3">
          {reportLocaleText.create.modal.title}
        </Typography>
      </Box>
    </Dialog>
  );
};
